export default __webpack_public_path__ + "static/faq-tablet-top-19346f5cb1fa351e9ca3df64c849f2f4.jpg";